import React from 'react';
import {injectIntl} from 'react-intl';
import DistancePin from "@Components/DistancePin";

function BranchListItem({intl, branchData, distance, appConfigs}) {
  const specs = branchData.name || [];

  const title = branchData && branchData.title ? branchData.title['0'] : ''
  let capitalizeTitle = title ? title.charAt(0).toUpperCase() + title.slice(1) : "";
  capitalizeTitle = capitalizeTitle.replace('Mcallen', 'McAllen').replace('Madison-wi', 'Madison-WI')

  const us_states = {
  "AL" : "Alabama",
  "AK" : "Alaska",
  "AS" : "American Samoa",
  "AZ" : "Arizona",
  "AR" : "Arkansas",
  "AA" : "Armed Forces(AA)",
  "AE" : "Armed Forces(AE)",
  "AP" : "Armed Forces(AP)",
  "CA" : "California",
  "CO" : "Colorado",
  "CT" : "Connecticut",
  "DE" : "Delaware",
  "DC" : "District of Columbia",
  "FL" : "Florida",
  "GA" : "Georgia",
  "GU" : "Guam",
  "HI" : "Hawaii",
  "ID" : "Idaho",
  "IL" : "Illinois",
  "IN" : "Indiana",
  "IA" : "Iowa",
  "KS" : "Kansas",
  "KY" : "Kentucky",
  "LA" : "Louisiana",
  "ME" : "Maine",
  "MH" : "Marshall Islands",
  "MD" : "Maryland",
  "MA" : "Massachusetts",
  "MI" : "Michigan",
  "FM" : "Micronesia",
  "MN" : "Minnesota",
  "MS" : "Mississippi",
  "MO" : "Missouri",
  "MT" : "Montana",
  "NE" : "Nebraska",
  "NV" : "Nevada",
  "NH" : "New Hampshire",
  "NJ" : "New Jersey",
  "NM" : "New Mexico",
  "NY" : "New York",
  "NC" : "North Carolina",
  "ND" : "North Dakota",
  "MP" : "Northern Mariana Islands",
  "OH" : "Ohio",
  "OK" : "Oklahoma",
  "OR" : "Oregon",
  "PW" : "Palau",
  "PA" : "Pennsylvania",
  "PR" : "Puerto Rico",
  "RI" : "Rhode Island",
  "SC" : "South Carolina",
  "SD" : "South Dakota",
  "TN" : "Tennessee",
  "TX" : "Texas",
  "UT" : "Utah",
  "VT" : "Vermont",
  "VI" : "Virgin Islands",
  "VA" : "Virginia",
  "WA" : "Washington",
  "WV" : "West Virginia",
  "WI" : "Wisconsin",
  "WY" : "Wyoming"
};


  const Specs = ({specs}) => {
    if (specs.length > 0) {
      return (
        <div className="list-item__description text--alternative">
          <ul>
            {specs.map(item => <li key={item}>{item}</li>)}
          </ul>
        </div>
      )
    } else {
      return null
    }
  };
  let state = '';
  if ("administrative_area" in branchData) {
    if (branchData.administrative_area) {
      let state_code = String(branchData.administrative_area);
      state = us_states[state_code.toUpperCase()] || '';
    }
  }
  return (
    <li className="list-item divider" style={{textTransform: "capitalize"}}>
      <div className="list-item__info">
        <div className="list-item__title">
          <h2 className="list-item__header">
            <a style={{textTransform: 'capitalize'}} className="list-item__link" href={branchData.url}>{capitalizeTitle}</a>
          </h2>
        </div>
        <DistancePin distance={distance} appConfigs={appConfigs}/>
        <ul className="list-item__meta">
          <li>{branchData.address_line1}</li>
          <li>{branchData.address_line2}</li>
          <li>{ (branchData.locality || '')+ ', '+state + ' ' + (branchData.postal_code || '')}</li>
          <li>
            <a href={`tel:${branchData.field_phone}`}>
              {branchData.field_phone}
            </a>
          </li>
        </ul>
        <Specs specs={specs} />
      </div>
      <a className="list-item__button button button--m" href={branchData.url[0]}>
        { intl.formatMessage({id: "BranchListItem.MoreInfoLabel"}) }
      </a>
    </li>
  );
}

export default injectIntl(BranchListItem);
